/**
 * Endpoint URL that the Billing app calls to pull usage from this PMS.
 *
 * Derived from VITE_API_URL — the same base `privateApi` uses (src/api/api.ts),
 * which already includes the `/api` prefix (e.g. `https://pms-api.example.com/api`).
 * Trailing slashes are stripped so we never produce `//v4`.
 */
const DEFAULT_API_URL = 'http://localhost:3000/api'; // same fallback as src/api/api.ts

export const getBillingUsageEndpointUrl = (): string => {
    const base = String(import.meta.env.VITE_API_URL || DEFAULT_API_URL).trim().replace(/\/+$/, '');
    return `${base}/v4/billing/usage`;
};

/** Clipboard helper with a fallback for insecure (plain http / LAN IP) contexts. */
export const copyTextToClipboard = (text: string): Promise<void> => {
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
    }
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        return successful ? Promise.resolve() : Promise.reject(new Error('Fallback copy failed'));
    } catch (err) {
        return Promise.reject(err);
    } finally {
        document.body.removeChild(textArea);
    }
};
